<template>
  <GwMenu
    ref="gwmenu"
    :placement="menuPosition"
    :flOptions="{ offset: 0, padding: 0 }"
  >
    <template #opener>
      <div
        class="csst clr-grey mdi prapmenu_opener icon_btn"
        :class="iconOpener"
        @mouseenter="
          e =>
            fl_positionTooltip(e, {
              offset: 2,
              placement: tooltipPosition,
              strategy: tooltipStrategy,
            })
        "
      >
        <div
          class="csst_content text-nowrap clr-white"
          v-html="$t('tooltips.preferences_floating_menu')"
        ></div>
      </div>
    </template>
    <template #default>
      <div
        class="gw_menu"
        style="--width: auto; max-height: var(--vh-10); overflow: auto"
      >
        <TrainerPreferences
          class="tracrls_preferences trainpref_mixed-options clr-white"
          :namespace="namespace"
          :hiddenOptions="hiddenOptions"
          :routerParams="routerParams"
          :visibleOptions="visibleOptions"
          @updateMode="id => $emit('updateMode', id)"
        />
      </div>
    </template>
  </GwMenu>
</template>

<script>
import GwMenu from '@/components/lib/GwMenu'
import TrainerPreferences from '@/components/Trainer/TrainerPreferences'
import float_mix from '@/mixins/float_mix'

export default {
  name: 'TrainerPreferencesMenu',
  components: {
    TrainerPreferences,
    GwMenu,
  },
  mixins: [float_mix],
  props: {
    namespace: { String, required: true },
    isClosed: Boolean,
    iconOpener: { type: String, default: () => 'mdi-dots-vertical' },
    menuPosition: { type: String, default: () => 'right-start' },
    tooltipPosition: { type: String, default: () => 'bottom' },
    tooltipStrategy: { type: String, default: () => 'fixed' },
    visibleOptions: { type: Array, default: null },
    hiddenOptions: { type: Array, default: null },
    routerParams: {
      type: Object,
      default: () => ({
        push: false,
        replace: false,
        saveLocally: false,
      }),
    },
  }, 
 emits: ['updateMode'],
}
</script>
<style lang="scss" scoped>
.prapmenu {
  display: flex;
  --opener-size: 1.5rem;
  &_opener {
    height: 2rem;
    width: 2rem;
    font-size: var(--opener-size);
  }
  // &_menu {
  //   padding: 1rem;
  //   line-height: 1.5;
  //   // min-width: 16rem;
  //   background: var(--clr-black-1);
  // }
}
</style>
